<template>
  <div role="dialog" :class="['modal',effect]" @click="backdrop&&action(false,1)" @transitionend="transition = false">
    <div :class="['modal-dialog modal-lg']" role="document" :style="{width: optionalWidth,height: optionalHeight}" @click.stop="action(null)">
      <div class="modal-content" :style="{height: optionalContentHeight}"  >
        <slot name="modal-header">
          <div class="modal-header">
            <button type="button" class="close" @click="action(false,2)"><span>&times;</span></button>
            <h4 class="modal-title"><slot name="title">{{title}}</slot></h4>
          </div>
        </slot>
        <slot name="modal-body"   ><div class="modal-body"  :style="{height: optionalBodyHeight}" ><slot></slot></div></slot>
        <slot name="modal-footer">
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="action(false,3)">{{ cancelText }}</button>
            <button type="button" class="btn btn-primary" @click="action(true,4)">{{ okText }}</button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>



var getScrollBarWidth = () => {
  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
    return 0
  }
  let inner = document.createElement('p')
  inner.style.width = '100%'
  inner.style.height = '200px'

  let outer = document.createElement('div')
  outer.style.position = 'absolute'
  outer.style.top = '0px'
  outer.style.left = '0px'
  outer.style.visibility = 'hidden'
  outer.style.width = '200px'
  outer.style.height = '150px'
  outer.style.overflow = 'hidden'
  outer.appendChild(inner)

  document.body.appendChild(outer)
  let w1 = inner.offsetWidth
  outer.style.overflow = 'scroll'
  let w2 = inner.offsetWidth
  if (w1 === w2) w2 = outer.clientWidth

  document.body.removeChild(outer)

  return (w1 - w2)
}

export default {
  props: {
    backdrop: {type: Boolean, default: true},
    callback: {type: Function, default: null},
    cancelText: {type: String, default: 'Close'},
    effect: {type: String, default: null},
    large: {type: Boolean, default: false},
    okText: {type: String, default: 'Save changes'},
    small: {type: Boolean, default: false},
    title: {type: String, default: ''},
    value: {type: Boolean, required: true},
    width: {default: null},
    height: {default: null},
    content_height: {default: null},
    body_height: {default: null},
  },
  data () {
    return {
      transition: false,
      val: null
    }
  },
  computed: {
    optionalBodyHeight() {
      if (this.body_height === null) {
        return null
      } else if (this.body_height.indexOf("%") > 0) {
        return this.body_height
      } else if (Number.isInteger(this.body_height)) {
        return this.body_height + 'px'
      }
      return this.body_height
    },
    optionalContentHeight() {
      if (this.content_height === null) {
        return null
      } else if (this.content_height.indexOf("%") > 0) {
        return this.content_height
      } else if (Number.isInteger(this.content_height)) {
        return this.content_height + 'px'
      }
      return this.content_height
    },
    optionalHeight () {
      if (this.height === null) {
        return null
      } else if (this.height.indexOf("%") > 0) {
        return this.height
      } else if (Number.isInteger(this.height)) {
        return this.height + 'px'
      }
      return this.height
    },
    optionalWidth () {
      if (this.width === null) {
        return null
      } else if (Number.isInteger(this.width)) {
        return this.width + 'px'
      }
      return this.width
    }
  },
  watch: {
    transition (val, old) {
      if (val === old) { return }
      const el = this.$el
      const body = document.body
      if (val) {//starting
        if (this.val) {
          el.querySelector('.modal-content').focus()
          el.style.display = 'block'
          setTimeout(() => el.classList.add('in'), 0)
          body.classList.add('modal-open')
          if (getScrollBarWidth() !== 0) {
            body.style.paddingRight = getScrollBarWidth() + 'px'
          }
        } else {
          el.classList.remove('in')
        }
      } else {//ending
        this.$emit(this.val ? 'opened' : 'closed')
        if (!this.val) {
          el.style.display = 'none'
          body.style.paddingRight = null
          body.classList.remove('modal-open')
        }
      }
    },
    val (val, old) {
      this.$emit('input', val)
      if (old === null ? val === true : val !== old) this.transition = true
    },
    value (val, old) {
      if (val !== old) this.val = val
    }
  },
  methods: {
    action (val,p) {
      if (val === null) { return }
      if (val && this.callback instanceof Function) this.callback()
      this.$emit(val ? 'ok' : 'cancel',p)
      this.val = val || false
    }
  },
  mounted () {
    this.val = this.value
  }
}
</script>
<style scoped>
.modal {
  transition: all 0.0s ease;
}
.modal.in {
  background-color: rgba(0,0,0,0.5);
}
.modal.zoom .modal-dialog {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  top: 300px;
  opacity: 0;
  -webkit-transition: all 0.0s;
  -moz-transition: all 0.0s;
  transition: all 0.0s;
}
.modal.zoom.in .modal-dialog {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transform: translate3d(0, -300px, 0);
  transform: translate3d(0, -300px, 0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// local-modal.vue?731303aa